import React, {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {Loader} from '../../../services/Loader'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {
  AuthFooter,
  formattedPhoneNumber,
  handleNotificationWithToastify,
  isCompanyGracePeriodExpired,
  maskEmail,
  maskPhoneNumber,
} from '../../../services/Functional'
import {
  getUserAccess,
  handleIsInOTPPage,
  handleTemporaryPassword,
  resendOTP,
  verifyOTP,
} from '../../../../setup/redux/auth/actions'
import {Link, useNavigate} from 'react-router-dom'
import {AuthSidePanel} from './AuthSidePanel'
import {CustomOtpInput} from './otpinput/CustomOtpInput'
import {ResendOTP} from './resendotp/ResendOtp'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface Payload {
  mobile_no?: string
  email?: string
  mode: 'mobile' | 'email'
}

export function Otp() {
  const dispatch: Dispatch<any> = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<boolean>(false)
  const [otp, setOTP] = React.useState('')

  const {
    config,
    user,
    subscription_renew_check,
    mode,
    inspectionCompanies,
    active_inspection_company,
  }: any = useSelector<RootState>(
    (state) => ({
      config: state.configuration.configurations,
      user: state.auth.user,
      mode: state.auth.mode,
      access_token: state.auth.access_token,
      subscription_renew_check: state.auth.subscription_renew_check,
      inspectionCompanies: state.auth.inspection_companies,
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )

  let values: Payload

  if (mode === 'mobile') {
    values = {
      mobile_no: formattedPhoneNumber(user?.country_code, user?.phone),
      mode: 'mobile',
    }
  } else {
    values = {
      email: user?.email,
      mode: 'email',
    }
  }

  const handleOTPChange = (otp: string) => {
    setOTP(otp)
  }

  // useEffect(() => {
  //   if (access_token && inspectionCompanies && inspectionCompanies.length > 0) {
  //     if (inspectionCompanies?.length > 1) {
  //       navigate('/company-select')
  //     } else {
  //       navigate('/dashboard')
  //     }
  //   }
  // }, [user, inspectionCompanies])

  useEffect(() => {
    if (subscription_renew_check && subscription_renew_check <= 0) {
      const gracePeriodExpiredComapny = isCompanyGracePeriodExpired(active_inspection_company)
      if (gracePeriodExpiredComapny) {
        navigate('/logout')
      }
    }
  }, [subscription_renew_check])

  const handleOTPSubmit = async () => {
    if (otp.length === 6) {
      setLoading(true)
      const response: any = await dispatch(verifyOTP({id: user?.id, otp}))
      if (response?.success) {
        setLoading(false)
        setHasErrors(false)
        localStorage.setItem('otpRemainingTime', '30')
        localStorage.setItem('otpResendCount', '0')
        localStorage.setItem('otpMaxResendCount', '3')
        dispatch(handleIsInOTPPage(false))
        dispatch(handleTemporaryPassword(undefined))
        await dispatch(getUserAccess())
        if (inspectionCompanies?.length > 1) {
          navigate('/company-select')
        } else {
          navigate('/dashboard')
        }
      } else {
        setLoading(false)
        setHasErrors(true)
        handleNotificationWithToastify(response)
        setTimeout(() => {
          setHasErrors(false)
          setOTP('')
        }, 5000)
      }
      setLoading(false)
    }
  }

  const handleBackButton = () => {
    navigate('/auth/login', {replace: true})
  }

  return (
    <>
      {loading && <Loader />}
      <div className='row w-100 h-100 p-0 m-0'>
        <div className='col-md-7 p-0 bg-white position-relative'>
          <div className='py-5 d-flex justify-content-between container align-items-center mb-8'>
            <img src={config && config?.actual_logo} alt='logo' width={90} />
            <Link
              to='https://decenthands.com/?page_id=4890'
              className='link-primary fs-6 float-end'
              target='_blank'
            >
              Contact Us
            </Link>
          </div>
          <div className='auth_form_container mx-auto d-flex justify-content-center align-items-center h-100'>
            <div className='h-100 otp_page_container'>
              <div className={`mb-5 animate__animated animate__fadeInUp`}>
                <h2 className='font-weight-bold otp_header'>6-Digit Code</h2>
              </div>
              <div className='mb-5 otp_sub_header animate__animated animate__fadeInUp'>
                You required the verify using OTP, 6 digit code has been sent to{' '}
                <OverlayTrigger
                  key='show'
                  placement='top'
                  overlay={
                    <Tooltip id='show'>
                      {mode === 'mobile'
                        ? maskPhoneNumber(user?.phone, user?.country_code)
                        : maskEmail(user?.email)}
                    </Tooltip>
                  }
                >
                  <span className='mask-otp-text'>
                    {mode === 'mobile'
                      ? maskPhoneNumber(user?.phone, user?.country_code)
                      : maskEmail(user?.email)}
                  </span>
                </OverlayTrigger>
              </div>
              <div className='mb-5'>
                <CustomOtpInput
                  label='otp'
                  otp={otp}
                  error={hasErrors}
                  handleOTPChange={handleOTPChange}
                  onEnterPress={handleOTPSubmit}
                  enableEnterKeySubmit={true}
                  className='otp_page_input animate__animated animate__fadeInUp'
                  separatorClassName='separator'
                />
              </div>
              <div className='mb-5'>
                <ResendOTP
                  className='animate__animated animate__fadeInUp'
                  APICalled={resendOTP(values)}
                  handleBackButton={handleBackButton}
                  showBackBtn={true}
                />
              </div>
              <button
                type='submit'
                disabled={otp.length < 6}
                tabIndex={3}
                onClick={handleOTPSubmit}
                className={`btn btn-primary btn-pill animate__animated animate__fadeInUp w-100 ${otp.length < 6 && 'disable-otp-btn'}`}
              >
                Sign in
                <img
                  className='ms-3'
                  src={'/media/icons/duotune/general/Arrow - Right.svg'}
                  alt='->'
                />
              </button>
            </div>
            <AuthFooter />
          </div>
        </div>
        <div className='col-md-5 p-0 background_card overflow-hidden position-relative'>
          <AuthSidePanel />
        </div>
      </div>
    </>
  )
}
